import * as React from "react";
import { Collapse } from "antd";
import { Info } from "react-feather";

const RESOURCE_TYPES = [
  "workload",
  "gvc",
  "identity",
  "secret",
  "policy",
  "group",
  "domain",
  "cloudaccount",
  "volumeset",
  "agent",
  "mk8s",
  "serviceaccount",
  "user",
  "ipset",
  "location",
  "auditctx",
];

const codeBlockStyle: React.CSSProperties = {
  display: "block",
  padding: "10px 14px",
  borderRadius: 6,
  backgroundColor: "var(--color-drop-secondary)",
  border: "1px solid var(--color-border)",
  color: "var(--color-default)",
  fontFamily: "input-mono-compressed, monospace",
  fontSize: 13,
  lineHeight: 1.6,
  overflowX: "auto",
};

const inlineCodeStyle: React.CSSProperties = {
  padding: "1px 5px",
  borderRadius: 4,
  backgroundColor: "var(--color-drop-secondary)",
  border: "1px solid var(--color-border)",
  color: "var(--color-default)",
  fontFamily: "input-mono-compressed, monospace",
  fontSize: "0.9em",
};

export const TagColumnsGuide: React.FC = () => {
  return (
    <div className="mb-4">
      <Collapse
        style={{ borderColor: "var(--color-border)" }}
        items={[
          {
            key: "1",
            label: <span className="font-medium">Custom Tag Columns for List Pages</span>,
            children: (
              <div style={{ color: "var(--color-default)" }}>
                <p style={{ marginBottom: 16, color: "var(--color-label)", lineHeight: 1.6 }}>
                  Add a tag with the key <code style={inlineCodeStyle}>cpln/console.tagColumns</code> to define which
                  resource tags appear as dedicated columns in list pages. Use <code style={inlineCodeStyle}>;</code> to
                  separate resource types and <code style={inlineCodeStyle}>,</code> to separate tag names.
                </p>

                <code style={codeBlockStyle}>workload=env,team,version;gvc=region,owner</code>

                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 8,
                    marginTop: 16,
                    padding: "10px 14px",
                    borderRadius: 6,
                    border: "1px solid var(--color-border)",
                    color: "var(--color-label)",
                    fontSize: 13,
                    lineHeight: 1.6,
                  }}
                >
                  <Info size={15} style={{ flexShrink: 0, marginTop: 2, color: "var(--color-link)" }} />
                  <span>
                    Column visibility is per-browser. After adding this tag, each user must enable columns via the
                    column settings button in the table header.
                  </span>
                </div>

                <details style={{ marginTop: 16, color: "var(--color-label)", fontSize: 13 }}>
                  <summary style={{ cursor: "pointer", color: "var(--color-link)" }}>
                    Available resource type keys
                  </summary>
                  <div style={{ marginTop: 8, fontFamily: "input-mono-compressed, monospace", lineHeight: 2 }}>
                    {RESOURCE_TYPES.map((type, i) => (
                      <React.Fragment key={type}>
                        {i > 0 && (
                          <span style={{ color: "var(--color-label)", margin: "0 4px", userSelect: "none" }}>
                            {"\u00b7"}
                          </span>
                        )}
                        <span style={{ color: "var(--color-default)" }}>{type}</span>
                      </React.Fragment>
                    ))}
                  </div>
                </details>
              </div>
            ),
            style: { borderColor: "var(--color-border)" },
          },
        ]}
      />
    </div>
  );
};
